import { countries } from '../../../constants/countries'
import { languages } from '../../../constants/languages'
import { MedicalId } from '../../../types'
import { getInitials } from '../../../utils/get-initials'
import { Badge } from './badge'
import { cn } from '../../../utils/cn'
import { getLocaleFormattedDate } from '../../../utils/date'

export const MedicalIdCard = ({ user }: { user: MedicalId }) => {
  const nationality = countries.find(
    (country) => country.code === user.nationality
  )

  const language = languages.find(
    (language) => language.code === user.languages?.[0]
  )

  return (
    <div className="bg-inverse-primary text-primary-white rounded-2xl p-3 gap-2 flex flex-col">
      <div className="flex-row flex gap-2 items-center">
        <div className="text-4xl font-bold bg-inverse-tertiary p-8 rounded-2xl w-30 h-30 flex items-center justify-center">
          <p className="text-inverse-primary text-6xl font-bold">
            {getInitials(user.fullName ?? '')}
          </p>
        </div>
        <h2 className={cn(
          'text-4xl font-bold line-clamp-3 text-ellipsis',
          user.fullName?.length && (
          user.fullName.length > 20 && user.fullName.length < 50 ?
          'text-2xl' : user.fullName.length >= 50 && 'text-xl')
        )}>{user.fullName}</h2>
      </div>
      <div className="flex flex-row gap-2">
        <Badge label={nationality?.name ?? ''} />
        <Badge label={language?.name ?? ''} />
        <Badge label={user.dateOfBirth ? getLocaleFormattedDate(user.dateOfBirth) : ''} />
      </div>
    </div>
  )
}
